import React from 'react';
import { Button } from 'tea-component';
import './index.scss';

/**
 * 返回按钮标题组件的属性接口
 */
interface IGoBackTitleProps {
  /** 标题文本 */
  title: string;
  /** 返回按钮点击事件处理器 */
  onGoBack?: () => void;
  /** 是否显示返回按钮，默认为 true */
  isShowGoBack?: boolean;
}

/**
 * 返回按钮标题组件
 * 用于显示带返回按钮的标题，常用于弹窗左侧头部
 */
const GoBackTitle: React.FC<IGoBackTitleProps> = ({
  title,
  onGoBack,
  isShowGoBack = true,
}) => (
  <div className="dbl-go-back-title">
    {isShowGoBack && (
      <Button
        // tea-layout 类名下 btnback类型的icon才会渲染黑色的箭头, 否则是蓝色的箭头
        className="tea-layout dbl-go-back-button"
        type="icon"
        icon="btnback"
        onClick={onGoBack}
      />
    )}
    <span className="dbl-go-back-title-text">{title}</span>
  </div>
);

export default GoBackTitle;